import { Button } from '@chakra-ui/react';

type PageSendButtonType = {
  colorTheme?: string;
  hoverColor?: string;
  text: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  type: 'button' | 'submit' | 'reset' | undefined;
  margin?: number;
  hidden?: boolean;
};

export const PageSendButton = ({
  colorTheme = 'blue',
  hoverColor = 'yellow',
  text,
  onClick,
  disabled,
  type,
  margin = 0,
  hidden = false,
}: PageSendButtonType) => {
  return (
    <>
      <Button
        whiteSpace="unset"
        width="100%"
        m={margin}
        type={type}
        paddingBlock={8}
        border="2px"
        bgColor={colorTheme + '.50'}
        color={colorTheme + '.600'}
        borderColor={colorTheme + '.500'}
        _hover={{
          bg: hoverColor + '.50',
          color: hoverColor + '.600',
          borderColor: hoverColor + '.500',
        }}
        onClick={onClick}
        isDisabled={disabled}
        hidden={hidden}
      >
        {text}
      </Button>
    </>
  );
};
